/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Parsnip = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="10"
    height="20"
    fill="none"
    viewBox="0 0 10 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.9488 19.104C3.0648 19.104 2.688 17.7504 2.184 15.36C1.836 13.6824 1.6944 13.2264 1.0152 11.5944L1.008 11.5776C0.5112 10.3824 0 9.14642 0 7.85042C0 6.90962 0.319201 6.01441 0.8976 5.32801C1.4568 4.66321 2.208 4.28161 2.9568 4.28161C3.0504 4.28161 3.1368 4.28881 3.2304 4.29601L3.5208 4.31761L1.692 1.944L2.6712 1.2L4.2288 3.15121V0H5.6688V3.15121L7.2264 1.2L8.2056 1.944L6.3792 4.31521L6.6696 4.29361C6.7632 4.28641 6.852 4.27921 6.9432 4.27921C7.692 4.27921 8.4408 4.66081 9.0024 5.32561C9.5808 6.01201 9.9 6.90722 9.9 7.84802C9.9 9.14642 9.3864 10.38 8.892 11.5752L8.8848 11.592C8.2224 13.1832 8.0808 13.6416 7.716 15.3576C7.2096 17.7504 6.8328 19.104 4.9488 19.104ZM2.9544 5.79121C2.1984 5.79121 1.536 6.75122 1.536 7.84802C1.536 8.80802 1.944 9.80402 2.3784 10.86L2.4336 10.9968C3.1008 12.6192 3.3168 13.2648 3.6936 15.048C3.8568 15.8712 4.056 16.7904 4.3416 17.2608C4.4856 17.496 4.6896 17.6136 4.9488 17.6136C5.208 17.6136 5.412 17.496 5.556 17.2608C5.8416 16.7904 6.0264 15.9048 6.204 15.0456C6.564 13.3008 6.7824 12.6504 7.4616 10.9944L7.5168 10.8576C7.9488 9.80162 8.3592 8.80322 8.3592 7.84562C8.3592 6.75122 7.6968 5.78881 6.9408 5.78881C6.7536 5.78881 6.5448 5.82001 6.3048 5.85841C5.9544 5.91361 5.5176 5.98081 4.9464 5.98081C4.3752 5.98081 3.9408 5.91361 3.588 5.85841C3.3504 5.82481 3.1416 5.79121 2.9544 5.79121Z" fill="currentColor" />
  </svg>
);

Parsnip.propTypes = propTypes;

export default Parsnip;
